
import Vue from "vue";
import SubHeader from "@/views/layout/header/SubHeader.vue";
import Search from "@/components/Search.vue";
import { Component } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import api from "@/api";
import TicketModel from "@/models/createTicket/TicketModel";
import TextFloating from "@/components/input/TextFloating.vue";
import FileInput from "@/components/input/FileInput.vue";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import utils from "@/utils";
import AttachmentModel from "@/models/createTicket/AttachmentModel";
import { UserModule } from "@/store/modules/user";
import dayjs from "dayjs";
import FeedbackListModel from "@/models/createTicket/FeedbackListModel";
@Component({
    components: {
        SubHeader,
        Search,
        MenuFooter,
        FileInput,

        ValidationObserver,
        ValidationProvider,
        TextFloating,
    },
})
export default class ListNotification extends Vue {
    mounted() {
        this.getDetailTicket(this.$route.params.id);
        this.getWoDetail(this.$route.params.id);
    }
    utils = utils;
    titlePage = "Assessment Report";
    userDetail = UserModule.userDetail;
    selectedDate = null;
    showCalendar = false;
    dayjs = dayjs;
    step = 0;
    ticket=[];
    page = 1;
    last_page = 0;

    readonly = false;

    getWoDetail(id) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getDetailTask2(id)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.readonly = response.data.data.status === "technical completion";
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }
    getDetailTicket(idTicket: string) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getFeedbacks((this.userDetail.accessgroup["name"]=== "User" ? "list?work_orders_id=":"list?work_orders_id=")+idTicket)
                .then((response) => {
                    if (response.data.code === 200) {
                        if(this.page == 1){
                            this.ticket = response.data.data;
                        }else{
                            this.ticket = [...this.ticket, ...(response.data.data as never[])] as never[];
                        }
                        this.last_page = response.data.meta.last_page;
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }
    goToDetail(id: string) {
    this.$router.push("/ticket-feedback-view/" + id);
    //   if (this.userDetail.accessgroup["name"] !== "User"){
    //   }else{
    //     this.$router.push("/ticket-feedback-approval/" + id);
    //   }
    }
    addFeedback() {
        this.$router.push("/ticket-feedback/" + this.$route.params.id);
    }
}
